module.exports = __webpack_public_path__ + "img/game_item_img5.48fb68da.jpg";